import ButtonComponent from './ButtonComponent';

const ButtonActionComponent = (props)=>{
    return (        
        <ButtonComponent onClick={props.onClick} className=" px-4 py-1 bg-secondary rounded font-medium text-white">
            {props.name}
        </ButtonComponent>
    )
}
export default ButtonActionComponent;